(function ($, ns) {
    'use strict';

    var cfg = {
        cache: {
            container: '[data-component="Dom.Accordion"]',
            sectionSelector: '.section-selector-target',
            accordionTarget: '.accordion-target',
            htmlBody: 'html, body',
            youtubeCard: '.youtube-card',
            youtubeCardBlock: '.card-block-overlay',
        },
        classes: {
            show: 'show',
            isShown: 'is-shown',
        },
        data: {
            parent: 'parent',
            target: 'target',
            scrollTo: 'scroll-to',
        },
        attributes: {
            ariaExpanded: 'aria-expanded',
        },
        events: {
            click: 'click',
            hide: 'accordion.hide',
            show: 'accordion.show',
            update: 'accordion.update',
            sectionUpdate: 'section.update',
        },
        options: {},
    };

    ns.Accordion = function (container) {
        this.container = container;
        this.settings = cfg;
        this.init();
    };

    ns.Accordion.prototype = {
        init: function () {
            this.cacheItems();
            this.bindEvents();
            this.activate();
        },
        cacheItems: function () {
            var settings = this.settings,
                cache = settings.cache,
                data = settings.data;

            var parentSelector = this.container.data(data.parent);
            this.parent = this.container.closest(parentSelector);

            var targetSelector = this.container.data(data.target);
            if (this.parent && this.parent.length) {
                this.target = this.parent.find(targetSelector);
                this.siblingsAndSelf = this.parent.find(cache.container);
                this.siblings = this.siblingsAndSelf.not(this.container);
                this.youtubeCard = this.parent.find(cache.youtubeCard);
            } else {
                this.target = $(targetSelector);
            }

            this.scrollTo = this.container.data(data.scrollTo) !== undefined;
            this.htmlBody = $(cache.htmlBody);

            this.isShown = false;
        },
        bindEvents: function () {
            var settings = this.settings,
                events = settings.events,
                cache = settings.cache,
                attributes = settings.attributes,
                classes = settings.classes;

            this.container.on(events.click, () => {
                if (this.siblings) {
                    this.siblings.trigger(events.hide);
                }

                if (!this.isShown) {
                    this.container.trigger(events.show);
                } else {
                    this.container.trigger(events.hide);
                }

                return false;
            });

            this.container.on(events.show, (event, data) => {
                // fix youtube card heights
                if (this.youtubeCard && this.youtubeCard.length > 0) {
                    for (
                        let index = 0;
                        index < this.youtubeCard.length;
                        index++
                    ) {
                        const element = this.youtubeCard[index];
                        let youtubeBlock = $(element).find(
                            cache.youtubeCardBlock
                        );
                        if (youtubeBlock) {
                            let blockHeight = youtubeBlock[0].clientHeight;
                            $(element).css(
                                'padding-bottom',
                                `calc(${blockHeight}px + 1.5rem)`
                            );
                            youtubeBlock.css(
                                'top',
                                `calc(100% - ${blockHeight}px - 2.5rem)`
                            );
                        }
                    }
                }

                // Force last state
                this.target.addClass(classes.show);
                // Get height in last step
                this.height = this.target.outerHeight();
                // Go back to first step
                this.target.removeClass(classes.show);

                // Apply height of last step and allow transition
                if (typeof requestAnimationFrame === 'undefined') {
                    this.target.css('height', this.height);
                } else {
                    // Use request animation frame. To trigger the animation in the next frame so no optimalisations happen
                    window.requestAnimationFrame(() => {
                        this.target.css('height', this.height);
                    });
                }

                this.container.attr(attributes.ariaExpanded, true);
                this.isShown = true;
                this.target.addClass(classes.isShown);

                // Update section selector
                window.setTimeout(() => {
                    this.target
                        .parents(cache.sectionSelector)
                        .trigger(events.sectionUpdate);
                    this.target
                        .parents(cache.accordionTarget)
                        .trigger(events.update);

                    if (this.scrollTo && (!data || !data.isInitialLoad)) {
                        this.htmlBody.animate(
                            {
                                scrollTop: this.container.offset().top - 150,
                            },
                            500
                        );
                    }
                }, 250);
            });

            this.container.on(events.hide, () => {
                this.target.css('height', '');
                this.container.attr(attributes.ariaExpanded, false);
                this.isShown = false;

                // Update section selector
                window.setTimeout(() => {
                    this.target
                        .parents(cache.sectionSelector)
                        .trigger(events.sectionUpdate);
                    this.target
                        .parents(cache.accordionTarget)
                        .trigger(events.update);
                }, 250);

                this.target.removeClass(classes.isShown);
            });

            this.target.on(events.update, (e) => {
                let target = $(e.currentTarget);

                if (!this.isShown) {
                    return;
                }

                // Force last state
                let prevHeight = target.css('height');
                target.css('height', '');

                target.addClass(classes.show);
                // Get height in last step
                let height = target.outerHeight();
                // Go back to first step
                target.removeClass(classes.show);
                target.css('height', prevHeight);

                // Apply height of last step and allow transition
                if (typeof requestAnimationFrame === 'undefined') {
                    target.css('height', height);
                } else {
                    // Use request animation frame. To trigger the animation in the next frame so no optimalisations happen
                    window.requestAnimationFrame(() => {
                        target.css('height', height);
                    });
                }

                //target.attr(attributes.ariaExpanded, true);
            });
        },
        activate: function () {
            var settings = this.settings,
                events = settings.events,
                attributes = settings.attributes;

            if (this.target.hasClass('section-selector')) {
                return;
            }

            if (window.location.hash) {
                let hash = window.location.hash,
                    hashTarget,
                    showTriggerd;

                if (hash.indexOf('=') === -1) {
                    hashTarget = $(hash);

                    if (hashTarget.is(this.target)) {
                        this.container.trigger(events.show, {
                            isInitialLoad: true,
                        });
                        showTriggerd = true;
                    }
                }

                if (
                    this.container.attr(attributes.ariaExpanded) == 'true' &&
                    !showTriggerd
                ) {
                    this.container.attr(attributes.ariaExpanded, false);
                }
            } else {
                if (this.container.attr(attributes.ariaExpanded) == 'true') {
                    this.container.trigger(events.show, {
                        isInitialLoad: true,
                    });
                }
            }
        },
    };

    return ns;
})(window.jQuery, window.Dom || {});
